module.exports = __webpack_public_path__ + "static/media/agentBackgroundImage.f5d9a31e.svg";